<template>
    <div class="p-3">
        <h3>RL 3.16 Kegiatan Pelayanan Keluarga Berencana</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Kegiatan Pelayanan Keluarga Berencana" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'year',
                    label: 'Tahun',
                    field: 'year',
                    type: 'year',
                    colClass: 'col-sm-3',
                    component: 'DropDownYear'
                }
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-keluarga-berencana',
                layout: 'fitDataStretch',
                responsiveLayout: 'collapse',
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",

                    },
                    {
                        title: "Jenis Pelayanan Keluarga Berencana",
                        field: "jenis",
                    },
                    {
                        title: "Pelayanan KB",
                        columns: [
                            {
                                title: "Pasca Persalinan",
                                field: "pasca_persalinan",
                                hozAlign: "center",
                            },
                            {
                                title: "Pasca Keguguran",
                                field: "pasca_keguguran",
                                hozAlign: "center",
                            },
                            {
                                title: "Interval",
                                field: "interval",
                                hozAlign: "center",
                            },
                            {
                                title: "Total",
                                field: "total_pelayanan",
                                hozAlign: "center",
                            },
                        ]
                    },
                    {
                        title: "Komplikasi KB",
                        field: "komplikasi",
                        hozAlign: "center",
                    },
                    {
                        title: "Kegagalam KB",
                        field: "kegagalan",
                        hozAlign: "center",
                    },
                    {
                        title: "Efek Samping",
                        field: "efek_samping",
                        hozAlign: "center",
                    },
                    {
                        title: "Drop Out",
                        field: "drop_out",
                        hozAlign: "center",
                    },
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
